import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const osv = defineConnector({
  identifier: "osv",
  name: "OSV",
  tagLine: "Open source vulnerability database",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.osv.dev"),
  auth: headerAuth([]),
  steps: [
    {
      title: "Set up OSV",
      items: [
        {
          kind: "markdown",
          content:
            "This public API requires no credentials. Use the default API URL. See the [API reference](https://google.github.io/osv.dev/api/).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.osv.dev",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the public API host documented in OSV’s official API examples: https://api.osv.dev. No tenant or regional host is required by the documented public API.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.osv.dev").trim().replace(/\/+$/, "") +
        "/v1/vulns/OSV-2020-111",
      ...{ method: "GET" },
    }),
  },
});
